export default __webpack_public_path__ + "static/media/logo.5328a9d2.svg";